(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .controller('oddQuestionTypeFreeTextController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        $scope.ctxtCtrl.maxLengthAttrIndex = _.findIndex($scope.boxModel.ODDQuestionAttributeValues, {'Code': 'MaxLength'});
        $scope.ctxtCtrl.maxLength = $scope.boxModel.ODDQuestionAttributeValues[$scope.ctxtCtrl.maxLengthAttrIndex].ValueText ?
            parseInt($scope.boxModel.ODDQuestionAttributeValues[$scope.ctxtCtrl.maxLengthAttrIndex].ValueText) : 200;

        $scope.ctxtCtrl.limitResponseSize = $scope.ctxtCtrl.maxLength > -1;

        var hintMaxLengthAttr = _.find($scope.boxModel.ODDQuestionAttributeValues, { 'Code': 'HintMaxLength' });
        $scope.ctxtCtrl.hintMaxLength = hintMaxLengthAttr.ValueText;

        // Field Initial Size
        var fieldInitSizeAttrIdx = _.findIndex($scope.boxModel.ODDQuestionAttributeValues, {'Code': 'FieldInitialSize'});
        $scope.ctxtCtrl.fieldInitialSize = $scope.boxModel.ODDQuestionAttributeValues[fieldInitSizeAttrIdx].ValueText;

        // If unlimited, default to 200 when showing limit input
        if ($scope.ctxtCtrl.maxLength === -1) {
            $scope.ctxtCtrl.maxLength = 200;
        }

        // limitResponseSizeChanged
        $scope.limitResponseSizeChanged = function () {
            if (!$scope.ctxtCtrl.limitResponseSize) {
                $scope.boxModel.ODDQuestionAttributeValues[$scope.ctxtCtrl.maxLengthAttrIndex].ValueText = '-1';
            } else {
                $scope.boxModel.ODDQuestionAttributeValues[$scope.ctxtCtrl.maxLengthAttrIndex].ValueText =
                    String.valueOf()($scope.ctxtCtrl.maxLength);
            }
        };

        // maxLengthChanged
        $scope.maxLengthChanged = function () {
            $scope.ctxtCtrl.maxLength = Math.floor($scope.ctxtCtrl.maxLength);
            if ($scope.ctxtCtrl.maxLength < 0) {
                $scope.ctxtCtrl.maxLength = Math.abs($scope.ctxtCtrl.maxLength)
            } else if ($scope.ctxtCtrl.maxLength === 0) {
                $scope.ctxtCtrl.maxLength = 200;
            }
            $scope.boxModel.ODDQuestionAttributeValues[$scope.ctxtCtrl.maxLengthAttrIndex].ValueText =
                String.valueOf()($scope.ctxtCtrl.maxLength);
        };

        // fieldSizeChanged
        $scope.fieldSizeChanged = function () {
            $scope.boxModel.ODDQuestionAttributeValues[fieldInitSizeAttrIdx].ValueText = $scope.ctxtCtrl.fieldInitialSize;
        }
    }
})();